import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
const pains = ['Estudiás horas y horas, pero llegás al examen y se te mezcla todo.', 'En la rotación clínica te quedás mudo cuando te preguntan una dosis.', 'La facultad te enseña teoría, pero no cómo actuar en una emergencia real.', 'No sabés cómo hablarle al dueño de la mascota sin sonar inseguro.', 'Sentís que cada año estudiás más y entendés menos cómo aplicarlo.'];
export function PainPoints() {
  return <section className="w-full bg-red-50/40 py-14 px-4 border-y border-red-100" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-red-700 mb-3" data-id="element-185">
          ¿Te suena familiar?
        </h2>
        <p className="text-center text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-186">
          La realidad del estudiante (y del recién graduado) de veterinaria que
          nadie te cuenta:
        </p>

        <ul className="space-y-3" data-id="element-187">
          {pains.map((pain, i) => <li key={i} className="flex items-start gap-3 bg-white border border-red-200 rounded-lg px-4 py-3 shadow-sm" data-id="element-188">
              <AlertCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-189" />
              <span className="text-red-700 font-medium leading-snug" data-id="element-190">
                {pain}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}